export const replaceNotNumber = function(val) {
  return `${val}`.replace(/[^0-9\\+]/gi, '');
};

export const replaceNumberOnlyDigits = function(val) {
  return `${val}`.replace(/[^0-9]/gi, '');
};
